import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {IncotermsComponent} from '../incoterms.component'
//Services
import {IncotermService} from 'src/app/core/services/parameters/incoterm.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CrearIncotermModal implements OnInit {

  newIncotermForm: FormGroup;
  loading = false;
  showAlert = false;
  date = new Date();

  constructor(
    public dialogRef: MatDialogRef<IncotermsComponent>,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private incotermService: IncotermService
  ) {
  }

  ngOnInit(): void {
    this.newIncotermForm = this.fb.group({
      description: [, Validators.required],
      incoterm: [, Validators.required]
    })
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.newIncotermForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.newIncotermForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.incoterm,
        description: form.value.description,
      }
      this.incotermService.createIncoterm(data).subscribe(_res => {
        this.alert.setNotice('Incoterms® 2020 creado correctamente', 'success');
        this.showAlert = true;
            this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo crear el incoterm', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
